module.exports = __webpack_public_path__ + "static/learn-what-hr-93a62e519d0918efd602d974d1982509.svg";